// Using CommonJS instead of ES2015+ export, because we also need to
// provide this object to Webpack in vue.config.js.
module.exports = {
  title: 'LoanDolphin',
  description: 'This is the landing page of the Smartgroup partner, using Loandolphin\'s internal tools.',
};
